"use strict";
// Very simple string-saving interface
Object.defineProperty(exports, "__esModule", { value: true });
exports.rPeek = exports.rEnd = exports.rString = exports.rBool = exports.rFloat = exports.rInt = exports.rHeader = exports.wString = exports.wBool = exports.wFloat = exports.wInt = exports.wEnd = exports.wHeader = exports.getResult = exports.reset = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var _accum = '';
var _idx = 0;
var _defaultDivider = '~';
var _divider = _defaultDivider;
var _newline = '\n';
function reset(accum) {
    if (accum === void 0) { accum = ''; }
    _accum = accum;
    _idx = 0;
    _divider = _defaultDivider;
}
exports.reset = reset;
function getResult() {
    return _accum;
}
exports.getResult = getResult;
function wHeader(namespace, version) {
    wString(namespace);
    wString(version);
    wString(_newline);
}
exports.wHeader = wHeader;
function wEnd(namespace) {
    wString(namespace + '-end');
    wString(_newline);
}
exports.wEnd = wEnd;
function wInt(v) {
    if (!Number.isInteger(v)) {
        throw new Error('wInt number is not integer! ' + v);
    }
    _accum += v.toFixed(0) + _divider;
}
exports.wInt = wInt;
function wFloat(v) {
    // _accum += v.toFixed(4) + _divider // TODO: limit to 4 decimal places?
    _accum += v + _divider;
}
exports.wFloat = wFloat;
function wBool(v) {
    wInt(v ? 1 : 0);
}
exports.wBool = wBool;
function wString(v) {
    if (v.includes(_divider)) {
        throw new Error('wString cannot contain |');
    }
    _accum += v + _divider;
}
exports.wString = wString;
function rHeader(namespace, version) {
    var n = rString();
    var v = rString();
    var nl = rString();
    assert_sidecar_1.assert.eq(n, namespace, 'namespace mismatch');
    assert_sidecar_1.assert.eq(v, version, 'version mismatch');
    assert_sidecar_1.assert.eq(nl, _newline, 'newline mismatch');
}
exports.rHeader = rHeader;
function rInt() {
    var idx = _accum.indexOf(_divider, _idx);
    if (idx === -1) {
        console.error('rInt', _accum, _idx);
        throw new Error('rInt');
    }
    var ss = _accum.substring(_idx, idx);
    var v = parseInt(ss, 10);
    if (Number.isNaN(v)) {
        console.error('NaN', '1-' + ss, '2-' + _idx, '3-' + idx);
    }
    _idx = idx + 1;
    return v;
}
exports.rInt = rInt;
function rFloat() {
    var idx = _accum.indexOf(_divider, _idx);
    if (idx === -1) {
        console.error('rFloat', _accum, _idx);
        throw new Error('rFloat');
    }
    var ss = _accum.substring(_idx, idx);
    var v = parseFloat(ss);
    if (Number.isNaN(v)) {
        console.error('NaN', '1-' + ss, '2-' + _idx, '3-' + idx);
    }
    _idx = idx + 1;
    return v;
}
exports.rFloat = rFloat;
function rBool() {
    return rInt() === 1;
}
exports.rBool = rBool;
function rString(expect) {
    if (expect === void 0) { expect = ''; }
    var idx = _accum.indexOf(_divider, _idx);
    if (idx === -1) {
        console.error('rString', _accum, _idx);
        throw new Error('rString');
    }
    var v = _accum.substring(_idx, idx);
    _idx = idx + 1;
    if (expect) {
        assert_sidecar_1.assert.eq(v, expect, 'string mismatch');
    }
    return v;
}
exports.rString = rString;
function rEnd(namespace) {
    var v = rString();
    var nl = rString();
    assert_sidecar_1.assert.eq(v, namespace + '-end', 'end namespace mismatch');
    assert_sidecar_1.assert.eq(nl, _newline, 'end newline mismatch');
}
exports.rEnd = rEnd;
function rPeek(expect) {
    var idx = _accum.indexOf(_divider, _idx);
    if (idx === -1) {
        console.error('rPeek', _accum, _idx);
        throw new Error('rPeek');
    }
    var v = _accum.substring(_idx, idx);
    return expect === v;
}
exports.rPeek = rPeek;
